import { Button } from '@/components/common/button'
import { LoadingBar } from '@/components/common/loadingBar'
import { CircleCheckIcon } from '@/components/icons/check'
import { ExternalLinkIcon } from '@/components/icons/externalLink'
import type { TabConfig } from '@/components/opportunity/useTabsConfig'
import { StatusMessage } from '@/components/shared/statusMessage'
import { routes } from '@/config/routes'
import type { SdkNetwork } from '@/types/network'
import { cn } from '@/utils/cn'
import { getExplorerLink } from '@/utils/explorer'
import { Link } from 'react-router'

interface TxSuccessMessageProps {
  activeConfig: TabConfig
  amount: string
  vaultNetwork: SdkNetwork
  resetTxState: () => void
  txHash?: string
  className?: string
}

export const TxSuccessMessage = ({ activeConfig, amount, vaultNetwork, className, txHash }: TxSuccessMessageProps) => {
  const { SuccessDescription } = activeConfig

  return (
    <StatusMessage className={cn('mb-0 lg:mb-0', className)}>
      <CircleCheckIcon size={48} className="zoom-in fade-in mx-auto animate-in text-accent" />
      <h6>{activeConfig.label} successful</h6>
      <SuccessDescription amount={amount} />
      {txHash && (
        <Button variant="default" size="default" className="inline-flex gap-2 text-xs underline" asChild>
          <a target="_blank" rel="noreferrer" href={`${getExplorerLink(vaultNetwork)}/tx/${txHash}`}>
            View transaction on the explorer
            <ExternalLinkIcon size={16} />
          </a>
        </Button>
      )}
      <p className="text-xs">
        You will be redirected to the{' '}
        <Button variant="default" size="default" className="rounded-full text-accent underline" asChild>
          <Link to={routes.dashboard} rel="noreferrer">
            Dashboard
          </Link>
        </Button>{' '}
        in a few seconds
      </p>
      <LoadingBar className="repeat-1 ease-linear [animation-duration:4000ms]" />
    </StatusMessage>
  )
}
